// extracted by mini-css-extract-plugin
export var indeterminate = "_5n-6";
export var md = "_5n-5";
export var semantic = "_5n-7";
export var sm = "_5n-4";
export var text = "_5n-8";
export var toggleControl = "_5n-0";
export var toggleInput = "_5n-1";
export var toggleSwitch = "_5n-2";
export var xs = "_5n-3";